// extracted by mini-css-extract-plugin
export default {"tooltip":"style_tooltip__WCd0S","tooltiptext":"style_tooltiptext__BrYVC"};